var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddWorkorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,11h4v2H13v4H11V13H7V11h4V7h2Zm9,1a10,10,0,1,1-2.929-7.07111A10,10,0,0,1,22,12Zm-2,0a8,8,0,1,0-2.34314,5.65686A8,8,0,0,0,20,12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWorkorder);
export default __webpack_public_path__ + "static/media/Add-workorder.266bf6ac9ed45541b34b527ff59a7b4b.svg";
export { ForwardRef as ReactComponent };